// 墨西哥 - 西班牙语
export default {
  mobile: 'Celular',
  payResult: 'Resultado de reembolso',
  plzInput: 'Ingrese el código de',
  plzPhone: 'Ingrese su número de teléfono móvil!',
  plzGraphicVerification: 'Ingrese el código de codigo de verificacion!',
  plzSms: 'Por favor, introduzca el codigo de verificacion que recibió!',
  plzPwd: 'Contraseña incorrecta, vuelva a intentar!',
  plzComPwd: 'Ingrese la Confirmación de contraseña!',
  plzGgree: 'Debería aceptar un acuerdo!',
  wrongPhone: 'Número equivocado!',
  more4: 'Más de 4 longitudes!',
  less4: 'Menos de 4 de longitud!',
  smsNoClick: 'Mensaje enviado, no se puede hacer clic!',
  smsSendSuccess: 'Enviado correctamente',
  graphicCode: 'Código gráfico',
  registerSuccess: '¡Registro exitoso!',
  wrongInvite: 'Código de invitación incorrecto!',
  needDownload: 'Necesitas descargar la aplicación para <br/>conseguir el dinero.',
  plzVerification: 'codigo de verificacion',
  plzSetPwd: 'Establezca la contraseña',
  comPwd: 'Confirmar contraseña',
  pwd: 'Establezca la contraseña',
  inviteCode: 'código de invitación (opcional）',
  accept: 'Acepto esto',
  termsOfUse: 'Términos de Uso',
  privacyPolicy: 'Política de privacidad',
  and: 'Y',
  registerNow: 'Regístrate ahora',
  notMatch2Pwd: 'Las dos contraseñas que ingresó no coinciden.',
  downloadNow: 'Descargar ahora',
  send: 'Mandar',
  resend: 'Volver a mandar',
  sending: 'Mandar',

  // 预授信
  approvalTitle: 'Solicitud de Préstamo',
  approvalWaiting: 'Solicitud en Proceso',
  approvalNoted: 'Nota',
  approvalWaitingNote: 'Ya recibimos su solicitud. Estamos trabajando en analizar su perfil crediticio y en un momento les hacemos saber el resultado a través de app y sms. ',
  approvalFailed: 'Fallo de auditoría',
  approvalFailedSubTitle: 'Solicitar nuevamente después de 24 horas',
  approvalFailedNote1: `¡Ups! Lamentamos informarle que por el momento `,
  approvalFailedNote2: ` no puede otorgarle el préstamo solicitado. La razón ha sido porque no hemos podido 😞 capturar suficiente información de su perfil crediticio 😔. Le hacemos una cordial invitación a solicitar su préstamo más adelante.`,
  approvalSuccess: 'Préstamo bancario',
  approvalSuccessNote: 'Su solicitud ya está aprobada y estamos trabajando en el depósito. Recibirá 1 centavo a su cuenta indicada para la verificación. Tardará entre 2 y 24 horas dependiendo de su banco.',
  // 警告
  approvalWarning: `<p>¡Cuidado con la estafa: No haga caso a los medios de pago distintos a la aplicacion. Para transferencia, su cuenta destinaria empieza con 646, banco: STP. Y para pago en OXXO indique OXXO PAY.</p>`,
  soonJumpHome: 'Solicitar un préstamo, A punto de volver a la página de inicio !',
  ok: 'OK',
  confirmar: 'CONFIRMAR',
  openingApp: 'Apertura de la aplicación',
  plzCheckUid: 'Por favor, compruebe que el enlace esté completo.',
  inviteFriends: 'invitar a amigos',
  cancel: 'cancelar',
  pageLoading: 'Página cargada, por favor más tarde...',
  repaymentProcessing: 'Procesamiento de reembolso',
  repayment: 'reembolso',
  aceptado: 'aceptado',
  waitResponse: 'por favor espere unos minutos para recibir la respuesta',
  copySuccess: 'Copia exitosa',
  copiedAndSend: 'Enlace de invitación copiado, por favor abra el mensaje y envíelo',
  isolezApplySuccessTitle: 'Depósito en proceso',
  tifiApplySuccessTitle: 'Préstamo aprobado',
  tifiApplySuccessNote: 'Su solicitud ya está aprobada y estamos trabajando en el depósito. Recibirá 1 centavo a su cuenta indicada para la verificación. Tardará entre 2 y 24 horas dependiendo de su banco.',
  isolezApplySuccessNote: `
    <ul>
      <li>Si tu solicitud fue realizada en un horario de lunes a viernes 9am-6pm y sábado 9am-1pm, para depósito en cuenta de los bancos BBVA o Banco Continental, BCP o Banco de Crédito,Scotiabank y Interbank, será reflejado máximo en 1 hora. Para el resto de las entidades financieras, en un lapso de 1 día hábil.</li>
    </ul>`
  ,
  parceCreditApplySuccessNote: `
    <ul>
      <li>Tu solicitud ya está aprobada. Estamos trabajando para que tengas el dinero en tu cuenta lo antes posible. Toma en cuenta que dependiendo del banco de tu cuenta, este proceso puede tardar de 2 a 72 horas.</li>
    </ul>
    `
}